module.exports = __webpack_public_path__ + "img/2026-03-24c_5.bf7a22df.jpg";